import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  LinkToReportCont,
  RiskAnalysisCell,
  RiskAnalysisSlideCont,
  RiskDescriptionCont,
  RiskDescTitle,
  RiskDescription,
  RiskDiagramCell,
} from './RiskAnalysisSlide.styles';
import { useFilters } from '../../../hooks/useFilters';
import { IRiskAnalysisResults } from '../../../hooks/useRiskAnalysis';
import DonutChart from '../../DonutChart/DonutChart';

interface IRiskAnalysisSlide {
  data: IRiskAnalysisResults;
  donutPartAction: (index: number) => void;
}

const RiskAnalysisSlide: FC<IRiskAnalysisSlide> = ({ data, donutPartAction }) => {
  const { t } = useTranslation();
  const { applyFilters } = useFilters();

  const { chart, name, result, risk } = data ?? {};
  const riskLevel = risk?.level || 'low';

  const navigateToResultsWithFilter = useCallback(() => {
    const riskFilter = JSON.stringify({ team: [], risk: [riskLevel] });

    applyFilters({
      compare: riskFilter,
      card: 'groupComparison',
      activeSection: null,
      riskAnalysis: null,
      surveyReport: null,
      prm: null,
      predictiveStates: null,
      pageNo: null,
      perPage: null,
      addTeam: null,
      performers: null,
    });
  }, [data, riskLevel]);
  const transformedDescription = risk?.description.replaceAll('<br />', ' ');

  return (
    <RiskAnalysisSlideCont id="RiskAnalysisSlideCont">
      <RiskAnalysisCell id="RiskAnalysisCell">
        <RiskDiagramCell id="RiskDiagramCell">
          <DonutChart
            colors={chart.colors}
            count={result.count}
            data={chart.data}
            dataKey="value"
            share={result.share}
            onClick={event => donutPartAction(Number((event.target as SVGGElement).id))}
          />
        </RiskDiagramCell>
      </RiskAnalysisCell>
      <RiskAnalysisCell id="RiskAnalysisCell">
        <RiskDescriptionCont id="RiskDescriptionCont">
          <RiskDescTitle id="RiskDescTitle">{name}</RiskDescTitle>
          <RiskDescription id="CaptionRegularM">{transformedDescription}</RiskDescription>
          <LinkToReportCont onClick={navigateToResultsWithFilter}>
            {t(`report.riskAnalysis.showTeams.${riskLevel}`)}
          </LinkToReportCont>
        </RiskDescriptionCont>
      </RiskAnalysisCell>
    </RiskAnalysisSlideCont>
  );
};

export default RiskAnalysisSlide;
